var map = {
	"./ATSI.png": "./src/assets/images/icons/header_svgs/ATSI.png",
	"./ECEC.svg": "./src/assets/images/icons/header_svgs/ECEC.svg",
	"./circle_icon.svg": "./src/assets/images/icons/header_svgs/circle_icon.svg",
	"./go_and_grow.svg": "./src/assets/images/icons/header_svgs/go_and_grow.svg",
	"./health_professional.svg": "./src/assets/images/icons/header_svgs/health_professional.svg",
	"./language_resources.svg": "./src/assets/images/icons/header_svgs/language_resources.svg",
	"./parents.svg": "./src/assets/images/icons/header_svgs/parents.svg",
	"./toolbox.svg": "./src/assets/images/icons/header_svgs/toolbox.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/icons/header_svgs sync recursive ^\\.\\/.*$";